export default __webpack_public_path__ + "static/media/Satisfaction Survey.1163c5cd.pdf";